import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsComponent } from "./terms/terms.component";
import { StripeComponent } from "./stripe/stripe.component";
import { ContactusComponent } from "./contactus/contactus.component";
import { FaqComponent } from "./faq/faq.component";
import { LandingComponent } from "./landing/landing.component";

import { LoginComponent } from "./auth/login/login.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { OtpComponent } from "./auth/otp/otp.component";
import { PersonalInformationComponent } from "./auth/personal-information/personal-information.component";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { AuthGuardService } from "./guard/auth-guard.service";
import { CodeOfConductComponent } from "./code-of-conduct/code-of-conduct.component";
import { RefundPolicyComponent } from "./refund-policy/refund-policy.component";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";

const routes: Routes = [
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "faq", component: FaqComponent },
  { path: "terms-condition", component: TermsComponent },
  { path: "contact-us", component: ContactusComponent },
  { path: "stripe", component: StripeComponent },
  { path: "code-of-conduct", component: CodeOfConductComponent },
  { path: "disclaimer", component: DisclaimerComponent },
  { path: "refund-policy", component: RefundPolicyComponent },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "login/:public_id",
    component: LoginComponent,
  },
  {
    path: "signup",
    component: SignupComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "reset-password/:token",
    component: ResetPasswordComponent,
  },
  {
    path: "otp-verification",
    component: OtpComponent,
  },
  {
    path: "personal-information",
    component: PersonalInformationComponent,
  },
  {
    path: "subscription",
    component: SubscriptionComponent,
  },
  {
    path: "subscription/:public_id",
    component: SubscriptionComponent,
  },
  {
    path: "",
    loadChildren: () =>
      import("src/app/base/base.module").then((m) => m.BaseModule),
  },
  {
    path: "home",
    loadChildren: () =>
      import("src/app/base/base.module").then((m) => m.BaseModule),
  },

  {
    path: "my-account",
    loadChildren: () => import('src/app/my-account/my-account.module').then(m => m.MyAccountModule),
  },


  {
    path: "manage-profile",
    loadChildren: () =>
      import("src/app/manage-profile/manage-profile.module").then((m) => m.ManageProfileModule),

  },

  // {
  //   path: "**",
  //   loadChildren: () =>
  //     import("src/app/auth/auth.module").then((m) => m.AuthModule),
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })], //{useHash: true}{useHash: true}
  exports: [RouterModule],
})
export class AppRoutingModule { }
